<template>
    <div class="bg-white px-3" style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important">
        <!-- 左边 -->
        <div style="margin: 5px; float: right">
            <el-button size="mini" type="success" @click="openModel">添加房型</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="room_type_text" label="房型" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="min_jzmj" label="面积/m²" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    {{scope.row.min_jzmj}} - {{scope.row.max_jzmj}}
                </template>
            </el-table-column>
            <el-table-column prop="min_price,max_price" label="价格/元" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    {{scope.row.min_price}} - {{scope.row.max_price}}
                </template>
            </el-table-column>
            <el-table-column prop="content" label="内容" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="status_text" label="状态" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="hot_text" label="推荐" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="sort" label="排序" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="names" :visible.sync="dialogVisible" top="20px" :append-to-body="true">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="房型">
                        <el-select v-model="ruleForm.room_type" placeholder="请选择" size="small" style="width: 30%">
                            <el-option v-for="item in room_options" :key="item.id" :label="item.content_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="面积">
                        <el-input v-model="ruleForm.min_jzmj" placeholder="请输入最小面积" style="width: 30%"></el-input>
                        <span>-</span>
                        <el-input v-model="ruleForm.max_jzmj" placeholder="请输入最大面积" style="width: 30%"></el-input>
                        <span style="font-size: 20px">/m²</span>
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input v-model="ruleForm.min_price" placeholder="请输入最低价" style="width: 30%"></el-input>
                        <span>-</span>
                        <el-input v-model="ruleForm.max_price" placeholder="请输入最高价" style="width: 30%">
                        </el-input>
                        <span style="font-size: 20px">/元</span>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="ruleForm.sort" placeholder="请输入内容" style="width: 30%"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-radio v-model="ruleForm.status" label="0">启用</el-radio>
                        <el-radio v-model="ruleForm.status" label="1">不启用</el-radio>
                    </el-form-item>
                    <el-form-item label="是否推荐">
                        <el-radio v-model="ruleForm.hot" label="1">是</el-radio>
                        <el-radio v-model="ruleForm.hot" label="0">否</el-radio>
                    </el-form-item>
                    <el-form-item label="设施">
                        <el-checkbox-group v-model="ruleForm.room_content_type">
                            <el-checkbox v-for="item in room_content_options" :key="item.id" :label="item.id"
                                :value="item.id">
                                {{item.content_name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="配套设施">
                        <!-- <el-select v-model="ruleForm.room_device_id" multiple collapse-tags placeholder="请选择" size="small" style="width: 30%">
                            <el-option v-for="item in room_device_id_options" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select> -->
                        <el-checkbox-group v-model="ruleForm.room_device_id">
                            <el-checkbox v-for="item in room_device_id_options" :key="item.id" :label="item.id"
                                :value="item.id">
                                {{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="主图">
                        <div>
                            <span v-if="!ruleForm.pic[0]" class="btn btn-light border mr-2" @click="chooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <img v-else :src="ruleForm.pic[0]" class="rounded"
                                style="width: 100px; height: 100px; cursor: pointer" @click="chooseImage" />
                        </div>
                    </el-form-item>
                    <el-form-item label="VR图">
                        <!-- <div>
                            <span class="btn btn-light border mr-2" @click="vrchooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <div v-for="(vrImg,index) in ruleForm.vr_url" :key="index">
                                <img :src="vrImg" class="rounded" style="width: 100px; height: 100px; cursor: pointer"
                                    @click="vrchooseImage" />
                            </div>

                        </div> -->
                        <uploadMoreImg :imgDatas="ruleForm.vr_url" @chooseImage="vrchooseImage" @deleteImage="vrdelete">
                        </uploadMoreImg>
                    </el-form-item>
                    <el-form-item label="平面图">
                        <!-- <div>
                            <span class="btn btn-light border mr-2" @click="pmchooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <div v-for="(pmImg,index) in ruleForm.pm_url" :key="index">
                                <img :src="pmImg" class="rounded" style="width: 100px; height: 100px; cursor: pointer"
                                    @click="pmchooseImage" />
                            </div>
                        </div> -->
                        <uploadMoreImg :imgDatas="ruleForm.pm_url" @chooseImage="pmchooseImage" @deleteImage="pmdelete">
                        </uploadMoreImg>
                    </el-form-item>
                    <el-form-item label="实景图">
                        <!-- <div>
                            <span class="btn btn-light border mr-2" @click="relchooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <div v-for="(relImg,index) in ruleForm.rel_url" :key="index">
                                <img :src="relImg" class="rounded" style="width: 100px; height: 100px; cursor: pointer"
                                    @click="relchooseImage" />
                                <div class="iconfont icon-cha"></div>
                            </div>

                        </div> -->
                        <uploadMoreImg :imgDatas="ruleForm.rel_url" @chooseImage="relchooseImage"
                            @deleteImage="deleteImageEvent"></uploadMoreImg>
                    </el-form-item>
                    <el-form-item label="内容">
                        <WangEditor ref="editor1" @editorContent="changeEditor" :editorContent="ruleForm.content"
                            :operateflag="operateflag" />
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
                <el-button @click="subForm" size="small" type="primary">提交</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue";
    import common from "@/common/mixins/common.js";
    const WangEditor = () => import("@/components/wangEnduit/index");
    import uploadMoreImg from "@/components/uploadMoreImg/uploadMoreImg.vue"
    export default {
        name: "originality",
        inject: ["app", "layout"],
        props: ["operateProjectId"],
        mixins: [common],
        components: {
            buttonSearch,
            WangEditor,
            uploadMoreImg
        },
        data() {
            return {
                tableData: [],
                loadings: false,
                height: null,
                names: "",
                dialogVisible: false,
                room_options: [],
                room_content_options: [],
                room_device_id_options: [],
                ruleForm: {
                    sort:'',
                    room_type: "",
                    min_jzmj: "",
                    max_jzmj: "",
                    min_price: "",
                    max_price: "",
                    room_device_id: [],
                    room_content_type: [],
                    status: '',
                    hot:'',
                    // describe: "",
                    pic: [],
                    content: "",
                    rel_url: [],
                    pm_url: [],
                    vr_url: []
                },
                rules: {},
                projectId: null,
                operateflag: "add",
            };
        },
        computed: {},
        mounted() {
            let that = this;
            // 项目id
            that.ruleForm.project_id = that.operateProjectId;
            that.search();
            that.getptss()
            that.getroom();
            that.getroom_content()
        },
        methods: {
            search() {
                let that = this;
                axios
                    .post(
                        "/admin/lgProjectRoomType/index", {
                            project_id: that.ruleForm.project_id
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.tableData = response.data.data;
                    })
                    .catch((error) => {});
            },
            getptss() {
                let that = this
                axios
                    .post(
                        "/admin/lgHomeDevice/index", {}, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.room_device_id_options = response.data.data;
                    })
                    .catch((error) => {});
            },
            getroom() {
                let that = this;
                axios
                    .post(
                        "/admin/DictionaryModel/RightList", {
                            source: "content",
                            sys_id: 3,
                            type_id: 4,
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.room_options = response.data.data;
                    })
                    .catch((error) => {});
            },
            getroom_content() {
                let that = this;
                axios
                    .post(
                        "/admin/DictionaryModel/RightList", {
                            source: "content",
                            sys_id: 3,
                            type_id: 7,
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.room_content_options = response.data.data;
                    })
                    .catch((error) => {});
            },
            chooseImage() {
                this.app.chooseImage((res) => {
                    this.ruleForm.pic = [];
                    this.ruleForm.pic.push(res[0].url);
                }, 1)
            },
            vrchooseImage() {
                this.app.chooseImage((res) => {
                    this.ruleForm.vr_url.push(res[0].url);
                    // this.ruleForm.vr_url = res[0].url
                }, 1)
            },
            vrdelete(index) {
                this.ruleForm.vr_url.splice(index, 1);
            },
            pmchooseImage() {
                this.app.chooseImage((res) => {
                    this.ruleForm.pm_url.push(res[0].url);
                    // this.ruleForm.pm_url = res[0].url
                }, 1)
            },
            pmdelete(index) {
                this.ruleForm.pm_url.splice(index, 1);
            },
            relchooseImage() {
                this.app.chooseImage((res) => {
                    this.ruleForm.rel_url.push(res[0].url);
                    // this.ruleForm.rel_url = res[0].url
                }, 1)
            },
            deleteImageEvent(index) {
                this.ruleForm.rel_url.splice(index, 1);
            },
            //             uploadPic: function(val) {
            // document.getElementById(val).click();
            // },
            // changeMulPic: function() {
            // var file = $("#filed").get(0).files[0];
            // $("#img").show();
            // this.imgsrcs.push(window.URL.createObjectURL(file))
            // },
            // deleteMulPic(index) {
            // this.imgsrcs.splice(index, 1);
            // }
            // },
            openModel() {
                let that = this;
                that.names = "新增";
                that.operateflag = "add";
                that.ruleForm.room_type = null;
                that.ruleForm.min_jzmj = null;
                that.ruleForm.max_jzmj = null;
                that.ruleForm.pic = [];
                that.ruleForm.vr_url = []
                that.ruleForm.pm_url = []
                that.ruleForm.rel_url = []
                that.ruleForm.min_price = null;
                that.ruleForm.max_price = null;
                that.ruleForm.room_device_id = []
                that.ruleForm.content = "";
                that.ruleForm.status = "";
                that.ruleForm.hot = "";
                that.ruleForm.sort = "";
                that.ruleForm.room_content_type = []
                that.dialogVisible = true;
            },
            subForm() {
                let that = this;
                let param = {
                    // id: 0,
                    project_id: null,
                    building_id: null,
                    floor_id: null,
                    room_type: null,
                    jzmj: null,
                    pic: [],
                    rel_url: [],
                    pm_url: [],
                    vr_url: [],
                    // room_content_type: [],
                    min_price: null,
                    max_price: null,
                    // describe: "",
                };
                let apiUrl = "";
                param = that.ruleForm;
                if (that.names == "新增") {
                    param.room_device_id = that.ruleForm.room_device_id.toString();
                    param.room_content_type = that.ruleForm.room_content_type.toString();
                    param.status = that.ruleForm.status
                    param.hot = that.ruleForm.hot
                    param.sort = that.ruleForm.sort
                    apiUrl = "/admin/lgProjectRoomType/Madd";
                }
                if (that.names == "编辑") {
                    // param.id = that.ruleForm.id;
                    param.room_device_id = that.ruleForm.room_device_id.toString();
                    // console.log("param.room_device_id",param.room_device_id.toString());
                    param.room_content_type = that.ruleForm.room_content_type.toString();
                    param.status = that.ruleForm.status
                    param.hot = that.ruleForm.hot
                    param.sort = that.ruleForm.sort
                    apiUrl = "/admin/lgProjectRoomType/Medit";
                }
                axios
                    .post(apiUrl, param, {
                        token: true,
                    })
                    .then((response) => {
                        if (response.data.code == 200) {
                            that.search();
                            that.dialogVisible = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.msg,
                                type: 'error'
                            });
                            that.dialogVisible = false
                        }
                    })
                    .catch((error) => {});
            },
            handleClick(row) {
                let that = this;
                that.names = "编辑";
                that.operateflag = "edit";
                console.log(row);
                that.ruleForm.id = row.id;
                if (row.room_device_id == null) {
                    that.ruleForm.room_device_id = []
                } else {
                    that.ruleForm.room_device_id = row.room_device_id.split(',').map(Number)
                }
                that.ruleForm.sort = row.sort;
                that.ruleForm.hot = row.hot.toString();;
                that.ruleForm.status = row.status.toString();
                that.ruleForm.project_id = row.project_id;
                that.ruleForm.room_type = row.room_type;
                that.ruleForm.min_jzmj = row.min_jzmj;
                that.ruleForm.max_jzmj = row.max_jzmj;
                that.ruleForm.room_content_type = row.room_content_type.split(',').map(Number)
                that.ruleForm.pic = [];
                if (row.pic != null) {
                    let dataPic = Object.values(row.pic);
                    that.ruleForm.pic = dataPic;
                }
                that.ruleForm.vr_url = [];
                if (row.vr_url != null) {
                    let vrPic = Object.values(row.vr_url);
                    that.ruleForm.vr_url = vrPic;
                }
                that.ruleForm.pm_url = [];
                if (row.pm_url != null) {
                    let pmPic = Object.values(row.pm_url);
                    that.ruleForm.pm_url = pmPic;
                }

                that.ruleForm.rel_url = [];
                if (row.rel_url != null) {
                    let relPic = Object.values(row.rel_url);
                    that.ruleForm.rel_url = relPic;
                }
                that.ruleForm.min_price = row.min_price;
                that.ruleForm.max_price = row.max_price;
                that.ruleForm.content = row.content;
                that.dialogVisible = true;
            },
            deleteClick() {},
            setClick(row) {
                let that = this
                that.dialogVisibles = true
                that.roomid = row.id
                that.bedloadings = true
                axios
                    .post("/admin/lgProjectRoomBed/index", {
                        room_id: that.roomid
                    }, {
                        token: true,
                    })
                    .then((response) => {

                        that.tableDatabed = response.data.data
                        that.bedloadings = false

                    })
                    .catch((error) => {});
            },

            // 富文本编辑器内部变更时回调父组件的方法
            changeEditor(param) {
                let that = this;
                that.ruleForm.content = param;
            },
        }

    };
</script>

<style scoped>
    .Mainpicture {
        float: left;
        width: 100px;
        height: 100px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid #E5E9F2;
    }

    .picture {
        min-height: 100px;
    }

    .files {
        display: none;
        float: left;
    }

    #img {
        margin-left: 20px;
        float: left;
        width: 100px;
        height: 100px;
        border-radius: 2px;
        border: 1px solid #E5E9F2;
    }

    .icon-cha {
        cursor: pointer;
        position: absolute;
        width: 10px;
        height: 10px;
        margin-left: 85px;
        margin-top: -100px;
        color: #BFC5D1;
    }

    #imgshow {
        width: 100px;
        height: 100px;
    }

    .icon-jia {
        text-align: center;
        width: 20px;
        height: 20px;
        line-height: 20px;
        color: #BFC5D1;
        padding: 40px;
        cursor: pointer;
    }
</style>